
import { computed, defineComponent, ref } from "vue";
import useState from "@/store";
import liff from "@line/liff";
import usePlugin from "@/plugins";
import { useConfirm } from "primevue/useconfirm";
import { UnlinkLineRequest } from "@/types";

export default defineComponent({
  name: "MainMenu",
  setup() {
    const { onLogout, axios } = usePlugin();
    const state = useState();
    const popup = ref(false);
    const menu = computed(() => {
      let result = [
        { label: "Home", icon: "pi pi-home pi-fw", to: { name: "Home" } },
        {
          label: "Config",
          icon: "pi pi-list pi-fw",
          to: { name: "ConfigService" },
        },
      ];

      if (state.value.isAdmin !== true) {
        result = result.filter((x) => x.label !== "Config");
      }

      return result;
    });

    const confirm = useConfirm();

    const unlink = async () => {
      confirm.require({
        header: "ออกจากระบบ",
        message: "ยืนยันเพื่อตัดการเชื่อมต่อกับ Line ออกจากระบบ ?",
        acceptLabel: "ยืนยัน",
        accept: async () => {
          await axios.post("api/v1/user/unlink", {
            userId: state.value.userId,
          } as UnlinkLineRequest);

          await liff.init({ liffId: state.value.liffId });
          if (liff.isLoggedIn() === true) {
            liff.logout();
          }
          onLogout();
        },
        rejectLabel: "ยกเลิก",
      });
    };

    const logout = async () => {
      confirm.require({
        header: "ออกจากระบบ",
        message: "ยืนยันเพื่อออกจากระบบ ?",
        acceptLabel: "ยืนยัน",
        accept: async () => {
          await liff.init({ liffId: state.value.liffId });
          if (liff.isLoggedIn() === true) {
            liff.logout();
          }
          onLogout();
        },
        rejectLabel: "ยกเลิก",
      });
    };
    return { menu, state, logout, popup, unlink };
  },
});
